import * as Blockly from 'blockly'
import { javascriptGenerator } from 'blockly/javascript'

let _initialized = false

/**
 * Register custom Blockly blocks (start_block) and generator overrides (text_print).
 * Safe to call multiple times — only runs once.
 */
export function ensureBlocklySetup(): void {
  if (_initialized) return
  _initialized = true

  // Custom "when run" start block
  Blockly.Blocks['start_block'] = {
    init: function () {
      this.appendDummyInput()
        .appendField('\u25B6  when run')
      this.setNextStatement(true, null)
      this.setColour(65)
      this.setDeletable(false)
      this.setMovable(true)
      this.setTooltip('Attach blocks below to run your program')
    }
  }

  javascriptGenerator.forBlock['start_block'] = function (_block: any) {
    return ''
  }

  // Override text_print to use console.log instead of window.alert
  javascriptGenerator.forBlock['text_print'] = function (block: any) {
    const msg = javascriptGenerator.valueToCode(block, 'TEXT', (javascriptGenerator as any).ORDER_NONE) || "''"
    return 'console.log(' + msg + ');\n'
  }
}
